module.exports = __webpack_public_path__ + "static/img/icon.33e0d405.svg";